import X from "../x.js";

class XRouter extends X {
  static get properties() {
    return {
      routes: {
        type: Object
      }
    };
  }

  constructor() {
    super();

    this.routes = {};

    document.addEventListener("click", event => {
      const link = event.composedPath().find(el => el.tagName === "A");

      if (link) {
        const url = new URL(link.href);
        if (url.origin === document.location.origin) {
          if (this.checkPath(url.pathname)) {
            event.preventDefault();
          }
        }
      }
    });

    window.addEventListener("popstate", event => {
      this.checkPath(document.location.pathname, false);
    });
  }
  
  updated(triggers) {
    if ("routes" in triggers) {
      this.checkPath(document.location.pathname);
    }
    
    return true;
  }

  checkPath(path, push = true) {
    const routes = Object.keys(this.routes);
    let matches = [];

    const match = routes.find(route => {
      matches = path.match(new RegExp(this.routes[route].pattern));
      return matches;
    });

    if (!match) return false;

    if (push) {
      history.pushState({}, "", path);
    }

    const routeInfo = this.routes[match];
    const params = matches.splice(1).reduce((all, value, index) => {
      return {
        ...all,
        [routeInfo.params[index]]: value
      };
    }, {});
    
    this.emit('x-update-route', {
      route: match,
      params,
    });

    return true;
  }
}

customElements.define("x-router", XRouter);
